import React, { useEffect, useState } from "react";
import HeaderPrint from "../../../Pdf/PrintHeaderAccount";
import axios from "axios";
import config from "../../../config";
import { calculateColumnTotal } from "../../Shared/Utility";
import { saleReportStyles } from "../../../Pdf/pdfStyles";
import PrintFooter from "../../../Pdf/PrintFooter";
import { PrintFormateNumber } from "../../../Pdf/PrintFormateNumber";
import {
  PDFViewer,
  Page,
  Text,
  View,
  Document,
} from "@react-pdf/renderer";
import { Spin } from "antd";
import moment from "moment";

const PAYABLE_COL = {
  sr: 26,
  name: 120,
  email: 130,
  mobile: 70,
  acType: 80,
  balance: 90,
  type: 51,
};
const PAYABLE_TABLE_WIDTH =
  PAYABLE_COL.sr +
  PAYABLE_COL.name +
  PAYABLE_COL.email +
  PAYABLE_COL.mobile +
  PAYABLE_COL.acType +
  PAYABLE_COL.balance +
  PAYABLE_COL.type;

const ORDER_LABELS = {
  1: "Name (A-Z)",
  2: "Name (Z-A)",
  3: "Amount (Low-High)",
  4: "Amount (High-Low)",
};

const normalizeEndDate = (raw) => {
  if (!raw) return null;
  const parsed = moment(raw);
  return parsed.isValid() ? parsed.format("YYYY-MM-DD") : null;
};

function PrintCashPayable() {
  const UserID = localStorage.getItem("ID");
  const AccessKey = localStorage.getItem("AccessKey");

  const urlParams = new URLSearchParams(window.location.search);
  const EndDateParam = urlParams.get("EndDate");
  const OrderBy =
    urlParams.get("OrderBy") || urlParams.get("orderby") || "1";

  const [listPayable, setListPayable] = useState([]);
  const [loading, setLoading] = useState(false);

  const apiEndDate = normalizeEndDate(EndDateParam);
  const asOfLabel = apiEndDate
    ? moment(apiEndDate).format(config.date_format)
    : moment().format(config.date_format);
  const orderLabel = ORDER_LABELS[Number(OrderBy)] || ORDER_LABELS[1];

  useEffect(() => {
    document.title = "Print Cash Payable";
    setLoading(true);

    const payload = {
      UserID: UserID,
      AccessKey: AccessKey,
      PageNo: 1,
      PageSize: 10000,
      EndDate: apiEndDate || undefined,
      OrderBy: OrderBy,
    };

    axios({
      method: "post",
      url: config.base_url + "Report/GetPayableReport",
      headers: { "Content-Type": "application/json" },
      data: payload,
    })
      .then(function (response) {
        if (response.data.status_code == 1) {
          setListPayable(response.data.listofLedger || []);
        }
        setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
        setLoading(false);
      });
  }, []);

  const totalBalance = calculateColumnTotal(listPayable, "Balance");

  const generateData = () => {
    if (listPayable.length > 0) {
      return listPayable.map((item, index) => (
        <View key={index} style={saleReportStyles.row}>
          <View style={[saleReportStyles.td, { width: PAYABLE_COL.sr }]}>
            <Text style={saleReportStyles.tdValue}>{index + 1}</Text>
          </View>
          <View style={[saleReportStyles.td, { width: PAYABLE_COL.name }]}>
            <Text style={saleReportStyles.tdValue}>{item.Name || "-"}</Text>
          </View>
          <View style={[saleReportStyles.td, { width: PAYABLE_COL.email }]}>
            <Text style={saleReportStyles.tdValue}>
              {item.Email_Address || "-"}
            </Text>
          </View>
          <View style={[saleReportStyles.td, { width: PAYABLE_COL.mobile }]}>
            <Text style={saleReportStyles.tdValue}>
              {item.Mobile_No || "-"}
            </Text>
          </View>
          <View style={[saleReportStyles.td, { width: PAYABLE_COL.acType }]}>
            <Text style={saleReportStyles.tdValue}>
              {item.Account_Type_BE?.Name || "-"}
            </Text>
          </View>
          <View
            style={[
              saleReportStyles.td,
              { width: PAYABLE_COL.balance, textAlign: "right" },
            ]}
          >
            <Text style={saleReportStyles.tdValue}>
              {PrintFormateNumber(item.Balance, 0)}
            </Text>
          </View>
          <View style={[saleReportStyles.td, { width: PAYABLE_COL.type }]}>
            <Text style={saleReportStyles.tdValue}>
              {item.BalanceType || "-"}
            </Text>
          </View>
        </View>
      ));
    }
  };

  const MyDocument = () => (
    <Document>
      <Page size="A4" style={saleReportStyles.page}>
        <HeaderPrint compact />

        <View style={saleReportStyles.section}>
          <View style={saleReportStyles.titleBlock}>
            <Text style={saleReportStyles.pagetitle}>Cash Payable Report</Text>
            <Text style={saleReportStyles.reportSubtitle}>
              As of: {asOfLabel}
            </Text>
            <Text style={saleReportStyles.reportSubtitle}>
              Order: {orderLabel}
            </Text>
          </View>

          <View style={saleReportStyles.table}>
            <View style={saleReportStyles.tableHead}>
              <View style={[saleReportStyles.th, { width: PAYABLE_COL.sr }]}>
                <Text style={saleReportStyles.thValue}>Sr. No.</Text>
              </View>
              <View style={[saleReportStyles.th, { width: PAYABLE_COL.name }]}>
                <Text style={saleReportStyles.thValue}>Name</Text>
              </View>
              <View style={[saleReportStyles.th, { width: PAYABLE_COL.email }]}>
                <Text style={saleReportStyles.thValue}>Email</Text>
              </View>
              <View style={[saleReportStyles.th, { width: PAYABLE_COL.mobile }]}>
                <Text style={saleReportStyles.thValue}>Mobile</Text>
              </View>
              <View style={[saleReportStyles.th, { width: PAYABLE_COL.acType }]}>
                <Text style={saleReportStyles.thValue}>A/C Type</Text>
              </View>
              <View
                style={[
                  saleReportStyles.th,
                  { width: PAYABLE_COL.balance, textAlign: "right" },
                ]}
              >
                <Text style={saleReportStyles.thValue}>Balance</Text>
              </View>
              <View style={[saleReportStyles.th, { width: PAYABLE_COL.type }]}>
                <Text style={saleReportStyles.thValue}>Type</Text>
              </View>
            </View>

            {generateData()}

            <View style={saleReportStyles.totalsRow}>
              <View
                style={[
                  saleReportStyles.th,
                  {
                    width:
                      PAYABLE_TABLE_WIDTH -
                      PAYABLE_COL.balance -
                      PAYABLE_COL.type,
                    textAlign: "right",
                  },
                ]}
              >
                <Text style={saleReportStyles.thValue}>Total Payables</Text>
              </View>
              <View
                style={[
                  saleReportStyles.th,
                  { width: PAYABLE_COL.balance, textAlign: "right" },
                ]}
              >
                <Text style={saleReportStyles.thValue}>
                  {PrintFormateNumber(totalBalance, 0)}
                </Text>
              </View>
              <View style={[saleReportStyles.th, { width: PAYABLE_COL.type }]}>
                <Text style={saleReportStyles.thValue}></Text>
              </View>
            </View>
          </View>

          <View
            style={{ marginBottom: 20, marginTop: 0, top: 6, bottom: 6 }}
            fixed
          >
            <Text
              style={{ fontSize: "7pt", color: "#000" }}
              render={({ pageNumber, totalPages }) =>
                `Page ${pageNumber} / ${totalPages}`
              }
            />
          </View>
        </View>
        <PrintFooter fixed />
      </Page>
    </Document>
  );

  return (
    <div style={{ width: "100%", height: "100vh", overflow: "hidden" }}>
      {loading ? (
        <div
          style={{
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Spin />
        </div>
      ) : (
        <PDFViewer width="100%" height="100%" fileName="CashPayable.pdf">
          <MyDocument />
        </PDFViewer>
      )}
    </div>
  );
}

export default PrintCashPayable;
